import { useEffect, useState } from "react";
import IMAGES from "../../constant/IMAGES";
import TextHeader from "../TextHeader";

const items = [
  {
    title: "Tầm nhìn",
    des: [
      "Xhero phấn đấu trở thành ứng dụng phong thủy tiên phong, dễ tiếp cận và uy tín nhất tại Việt Nam và quốc tế.",
    ],
  },
  {
    title: "Sứ mệnh",
    des: [
      "Nâng cao chất lượng cuộc sống thông qua ứng dụng phong thủy khoa học và thực tiễn.",
      "Đưa ra quyết định sáng suốt trong mọi khía cạnh của cuộc sống dựa trên kiến thức phong thủy chính xác.",
      "Kết nối với cộng đồng những người quan tâm đến phong thủy và chia sẻ kiến thức, kinh nghiệm lẫn nhau.",
    ],
  },
  {
    title: "Giá trị cốt lõi",
    des: [
      "Tâm yêu thương: Mọi hành động đối với khách hàng và đồng nghiệp đều xuất phát từ Tâm yêu thương",
      "Khát vọng: Khát vọng trở thành người có giá trị bằng cách lan tỏa giá trị.",
      "Tầm nhìn: Tầm nhìn rộng mở để có cuộc sống hạnh phúc và thành công",
    ],
  },
  {
    title: "Triết lý kinh doanh",
    des: [
      "Giúp một người tiến bộ là giúp nhiều người đạt hạnh phúc.",
      "Giá trị lớn chỉ có ý nghĩa khi được chia sẻ cho nhiều người.",
      "Thuận theo quy luật sẽ giúp chúng ta tận hưởng cuộc sống tốt đẹp hơn.",
    ],
  },
];
const SectionAbout = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
        }
      },
      {
        threshold: 0.1,
      }
    );

    const phoneElement = document.querySelector(".phone-animation");
    if (phoneElement) {
      observer.observe(phoneElement);
    }

    return () => {
      if (phoneElement) {
        observer.unobserve(phoneElement);
      }
    };
  }, [hasAnimated]);

  return (
    <div id="ve-chung-toi" className="xl:scroll-m-52 scroll-m-32 relative">
      <TextHeader text="VỀ CHÚNG TÔI" />
      <div className="flex lg:flex-row flex-col items-start justify-between gap-8 2xl:gap-20">
        <div className="flex-1 flex flex-col items-center justify-center gap-[106px] relative">
          <div
            className="flex flex-col pt-[55px] gap-5"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="800"
          >
            <p className="font-bold text-xl md:text-[32px]/[38.21px] text-white">
              Xhero - Phong thủy trong tầm tay
            </p>
            <p className="text-sm md:text-2xl text-[#FAFAFA] leading-9 text-justify">
              Xhero cam kết mang đến cho người dùng trải nghiệm phong thủy thông
              minh, chính xác và hiệu quả, góp phần nâng cao chất lượng cuộc
              sống và tạo dựng cộng đồng phong thủy gắn kết.
            </p>
          </div>
          <div className="relative flex-col lg:flex hidden items-center justify-center overflow-hidden z-[2]">
            <img
              src={IMAGES.phoneImage}
              alt="phone"
              className={`phone-animation w-[50%] ${
                hasAnimated ? "animate-slideUp opacity-100" : "opacity-0"
              }`}
            />
            <img
              src={IMAGES.underPhone}
              alt="underPhone"
              className="w-[60%] z-10"
            />
          </div>
          <img
            src={IMAGES.waveAbout}
            alt="wave"
            className="absolute bottom-[5%] left-1/2 -translate-x-[27%] lg:ml-52 lg:block hidden"
          />
        </div>
        <div
          className="flex-1 flex flex-col gap-3 md:gap-[30px] relative z-[1]"
          data-aos="fade-left"
          data-aos-duration="1000"
          data-aos-delay="800"
        >
          {items.map((item, index) => (
            <div
              key={index}
              className={`relative p-4 md:p-[40px] flex flex-col gap-[30px] bg-gradient-to-b from-[#292A2C] to-[#000000] cursor-pointer ${
                activeIndex === index
                  ? "gradient-borderFull max-h-[500px] "
                  : "md:max-h-[156px] max-h-[66px]"
              } rounded-[20px] md:rounded-[45px] transition-all duration-700 ease-linear overflow-hidden`}
              onClick={() => setActiveIndex(index)}
            >
              <img
                src={IMAGES.overlay}
                alt="overlay"
                className={`absolute top-0 left-0 w-full h-full pointer-events-none ${
                  activeIndex === index ? "opacity-80" : "opacity-0"
                } transition-all duration-300 ease-linear object-cover`}
              />
              <div className="flex items-center justify-between">
                <div className="flex gap-6 items-center">
                  <div
                    className={`${
                      activeIndex === index
                        ? "gradient-borderFull bg-gradient-to-b from-[#5C3D2B] to-[#331F15]"
                        : "gradient-borderYellow"
                    }  md:px-4 md:py-2 p-[6px] rounded-md md:rounded-xl `}
                  >
                    <p
                      className={`${
                        activeIndex === index
                          ? "text-goldGradient"
                          : "text-yellowGradient"
                      } text-base md:text-[40px]/[47.76px] font-medium transition-all duration-300 ease-linear`}
                    >
                      0{index + 1}
                    </p>
                  </div>
                  <p
                    className={`${
                      activeIndex === index
                        ? "text-goldGradient"
                        : "text-yellowGradient"
                    } font-medium text-lg md:text-[30px]/[35.82px] transition-all duration-300 ease-linear `}
                  >
                    {item.title}
                  </p>
                </div>
                <img
                  src={
                    activeIndex === index ? IMAGES.minusIcon : IMAGES.plusIcon
                  }
                  alt="icon"
                  className="size-6 md:size-14"
                />
              </div>
              <img
                src={IMAGES.line}
                alt="line"
                className={activeIndex === index ? "opacity-100" : " opacity-0"}
              />
              <ul className="max-w-3xl text-[#F0D35A] text-sm md:text-2xl lg:text-lg ml-6 text-justify">
                {item.des.map((item) => (
                  <li className="list-disc" key={item}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionAbout;
